<div class="left-container-toolbar">
    <!--	<ng-container *ngIf="isStandardView">
		<button (click)="createReport()" class="primary" type="button">
			{{'generic.toolbar.addNew' | translate}}
		</button>
	</ng-container>-->

    @if (isCreateView || isEditView) {
        <button class="primary" type="submit" form="register-form">
            {{ 'generic.buttons.save' | translate }}
        </button>
    }
</div>
<div class="right-container-toolbar">
    @if (isStandardView) {
        <app-search-bar [(value)]="searchValue" [data]="data" />
    }
</div>
